export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-paper px-6 md:px-12 py-14 border-t border-paper/10"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-12 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-6">
          <div className="serif text-xl md:text-2xl tracking-tight font-medium text-paper">
            Saran Gandhi &amp; Associates
          </div>
          <div className="overline text-paper/60 mt-2">
            Strategy · Operations · Exit Readiness
          </div>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="overline text-paper/60 mb-3">Direct</div>
          <a
            href="mailto:saran@sarangandhi.com"
            className="block text-sm text-paper/80 hover:text-brass transition-colors"
            data-testid="footer-email"
          >
            saran@sarangandhi.com
          </a>
          <a
            href="tel:+447878781100"
            className="block text-sm text-paper/80 hover:text-brass transition-colors mt-2 mono"
            data-testid="footer-phone"
          >
            +44 7878 781 100
          </a>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="overline text-paper/60 mb-3">Book</div>
          <a
            href="https://calendly.com/sarangandhi1/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-paper/80 hover:text-brass transition-colors link-line"
            data-testid="footer-calendly"
          >
            30-minute consultation →
          </a>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto mt-12 pt-6 border-t border-paper/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div className="overline text-paper/50">
          © {year} Saran Gandhi &amp; Associates · All rights reserved
        </div>
        <div className="overline text-paper/50">
          London · UK
        </div>
      </div>
    </footer>
  );
}
